/**
 * Technician Toolbox Types
 * Private, technician-owned tool inventory
 */

export type ToolboxCategory = 
  | 'scan_tool'
  | 'electrical_diagnostics'
  | 'adas'
  | 'driveability'
  | 'diesel'
  | 'hvac'
  | 'programming'
  | 'specialty'
  | 'hand_tools'
  | 'tech_equipment'
  | 'other';

export const TOOLBOX_CATEGORY_LABELS: Record<ToolboxCategory, string> = {
  scan_tool: 'Scan Tools',
  electrical_diagnostics: 'Electrical Diagnostics',
  adas: 'ADAS',
  driveability: 'Driveability',
  diesel: 'Diesel',
  hvac: 'HVAC',
  programming: 'Programming',
  specialty: 'Specialty Tools',
  hand_tools: 'Hand Tools',
  tech_equipment: 'Tech-Owned Equipment',
  other: 'Other',
};

export const TOOLBOX_CATEGORY_ORDER: ToolboxCategory[] = [
  'scan_tool',
  'electrical_diagnostics',
  'adas',
  'driveability',
  'diesel',
  'hvac',
  'programming',
  'specialty',
  'hand_tools',
  'tech_equipment',
  'other',
];

export interface TechnicianTool {
  id: string;
  technician_profile_id: string;
  name: string;
  category: ToolboxCategory;
  brand: string | null;
  model: string | null;
  part_number: string | null;
  serial_number: string | null;
  purchase_price: number | null;
  purchase_date: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export interface TechnicianToolMedia {
  id: string;
  tool_id: string;
  technician_profile_id: string;
  storage_path: string;
  is_primary: boolean;
  created_at: string;
}

export interface TechnicianToolWithMedia extends TechnicianTool {
  media: TechnicianToolMedia[];
  primary_photo_url?: string | null;
}

export interface CreateToolInput {
  technician_profile_id: string;
  name: string;
  category: ToolboxCategory;
  brand?: string | null;
  model?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  purchase_price?: number | null;
  purchase_date?: string | null;
  notes?: string | null;
}

export interface UpdateToolInput {
  id: string;
  name?: string;
  category?: ToolboxCategory;
  brand?: string | null;
  model?: string | null;
  part_number?: string | null;
  serial_number?: string | null;
  purchase_price?: number | null;
  purchase_date?: string | null;
  notes?: string | null;
}

/**
 * Parsed tool data from AI vision analysis
 */
export interface ParsedToolData {
  name: string | null;
  brand: string | null;
  model: string | null;
  part_number: string | null;
  serial_number: string | null;
  category: ToolboxCategory;
  confidence: number;
}
